import { FEIL, HN_SKJEMA_ERRORCODES_RESOURCES, HN_SKJEMA_FRONTEND_RESOURCES, LOGGETUT_FEILCODES } from 'src/constants/constants';
import { useResources } from 'src/resources';
import { hentOversettelse } from 'src/util/stringToLanguageLocales';

import type { HNSkjemaErrorCodes, HNSkjemaFrontend } from 'src/types/Resources';

export const getSkjemaErrorTitleFromResources = ({
  resources,
  error,
  key,
}: {
  resources: HNSkjemaFrontend;
  error?: string;
  key: keyof HNSkjemaFrontend;
}): string => {
  if (!resources) {
    return FEIL;
  }

  return error && LOGGETUT_FEILCODES.indexOf(error) > -1
    ? hentOversettelse('loggetut_feil_tittel', resources)
    : hentOversettelse(key, resources);
};

export const getSkjemaErrorBodyFromResources = ({
  resources,
  errorMessage,
  key,
}: {
  resources: HNSkjemaFrontend;
  errorMessage?: string;
  key: keyof HNSkjemaFrontend;
}): string => {
  if (!resources) {
    return FEIL;
  }
  if (!errorMessage) {
    return hentOversettelse(key, resources);
  }

  return errorMessage;
};

export const useGetSkjemaErrorTitleAndBodyFromResources = ({
  error,
  errorCode,
  titleKey,
  bodyKey,
}: {
  error?: string;
  errorCode?: string;
  titleKey: keyof HNSkjemaFrontend;
  bodyKey: keyof HNSkjemaFrontend;
}): { errorTitle: string; errorBody: string } | null => {
  const resources = useResources<HNSkjemaFrontend>(HN_SKJEMA_FRONTEND_RESOURCES);
  const errorCodesResources = useResources<HNSkjemaErrorCodes>(HN_SKJEMA_ERRORCODES_RESOURCES);
  const resourceKey = errorCode?.replace('-', '_').replace(/^./, char => char.toLowerCase()) as keyof HNSkjemaErrorCodes | undefined;
  const errorMessage = resourceKey ? errorCodesResources?.[resourceKey] : undefined;
  if (!resources) {
    return null;
  }
  return {
    errorTitle: getSkjemaErrorTitleFromResources({ resources, error, key: titleKey }),
    errorBody: getSkjemaErrorBodyFromResources({ resources, errorMessage: errorMessage, key: bodyKey }),
  };
};
